<template>
    <div class="powerView" v-if="dialogVisible">
        <el-dialog title="权限详情" :visible.sync="dialogVisible" @close="cancel" width="488px">
            <img :src="imgPower" alt="" class="img">
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
  export default {
    name: 'powerView',
    data() {
      return {
          imgPower: require('@/common/images/brandBusiness/img_power.png'),
          dialogVisible:false
      }
    },
    mounted() {
    },
    methods: {
        openDialog() {
            this.dialogVisible = true
        },
        cancel() {
            this.dialogVisible = false
        },
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .powerView {
        .img{
            width: 448px;
            height: 520px;
        }
        .el-dialog__footer{
            padding: 0;
        }
    }
</style>
